import { createAction } from "redux-act";
export const FETCH_DROPDOWN_DATA = "GET_DROPDOWN_DATA";
export const FETCH_FAILED_DROPDOWN_DATA = "GET_DROPDOWN_FAILED";
export const FETCHED_DROPDOWN_DATA = "GET_DROPDOWN_SUCCESS";

export const fetchDropdownData = createAction(FETCH_DROPDOWN_DATA, (payload) => payload);
export const fetchedDropdownData = createAction(FETCHED_DROPDOWN_DATA);
export const fetchFailedDropdownData = createAction(FETCH_FAILED_DROPDOWN_DATA);
